import { render, staticRenderFns } from "./Prisma.vue?vue&type=template&id=35a804dc&scoped=true&"
import script from "./Prisma.vue?vue&type=script&lang=js&"
export * from "./Prisma.vue?vue&type=script&lang=js&"
import style0 from "./Prisma.vue?vue&type=style&index=0&id=35a804dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a804dc",
  null
  
)

export default component.exports